import Button from "./Button";
import "../Info.css"

const AFRUe = ()=>{
    return(
        <div className="infoalbum">
        <h1 className="title">APOCALYPSE: FROM US</h1>
        <div className="infoal">
          <div className="infotext">
            <Button/>
            <p>- POBs = from <span className="colorunoa">10usd</span><span className="colordosa"> 8 usd</span></p>
            <p className="ver">LIMITED (ver. W)</p>
            <p>- Limited Photobook (cd+pb) =<span className="colorunoa">9,5usd</span> <span className="colordosa"> 8 usd</span></p>
            <p>- Limited photocard = <span className="colorunoa">5usd</span> <span className="colordosa"> 10 usd</span></p>
            <p>- Passaport Case =  <span className="colorunoa">1,5usd</span> <span className="colordosa"> 2 usd</span></p>
            <p>- Boarding Pass =<span className="colorunoa">1usd</span> <span className="colordosa"> 1 usd</span></p>
            <p>- Paper plane = <span className="colorunoa">1,2usd</span><span className="colordosa"> 1 usd</span></p>
            <p>- Postals(Set ot7) = $800 c/u <span className="colorunoa">0,8usd</span> <span className="colordosa"> 8 usd set</span></p>
            <p>- Limited POB poster = <span className="colorunoa">1usd</span> <span className="colordosa"> 1usd</span></p>
            <p>- Stickers = <span className="colorunoa">0,8usd</span> <span className="colordosa"> 0,5 usd</span></p>
            <p>- Bookmark = <span className="colorunoa">0,5usd</span> <span className="colordosa"> 0,1 usd</span></p>
            <p>- Film = <span className="colorunoa">1usd</span> <span className="colordosa"> 2 usd</span></p>
            <p className="ver">NORMAL (ver. A,Y)</p>
            <p>- Photobook (cd+pb) = <span className="colordosa"> 7 usd</span> <span className="colordosa"> 5 usd</span></p>
            <p>- Photocard = <span className="colorunoa">3usd</span> <span className="colordosa"> 2 usd</span></p>
            <p>- Stickers = <span className="colorunoa">0,88usd</span> <span className="colordosa"> 0,5 usd</span></p>
            <p>- Bookmark = <span className="colorunoa">0,5usd</span> <span className="colordosa"> 0,1 usd</span></p>
            <p>- Film = <span className="colorunoa">1usd</span> <span className="colordosa"> 2 usd</span></p>
            <p>- POB Poster= <span className="colorunoa">0,8usd</span> <span className="colordosa"> 1 usd</span></p>
            <p className="ver">PLATFORM</p>
            <p>- Envelope = <span className="colorunoa">1usd</span> <span className="colordosa"> 0,2 usd</span></p>
            <p>- Photocard = <span className="colorunoa">3,5usd</span> <span className="colordosa"> 5 usd</span></p>
            <p>- PC set =  <span className="colorunoa">0,8usd c/u</span> <span className="colordosa"> 5 usd set</span></p>
            <p>- PVC Photocard (QR) =<span className="colorunoa">3,5usd</span> <span className="colordosa"> 5</span></p>
          </div>
          <div className="infoalimg ">
    <img src="https://i.pinimg.com/736x/ed/53/62/ed5362f89bf6f9af52c58b269dca85bc.jpg" alt="Album Cover" style={{ boxShadow: "3.5px 3.5px 0px rgb(82, 228, 42)" }} />
    </div>
        </div>
      </div>
      )
}

export default AFRUe;